module.exports = __webpack_public_path__ + "static/media/clauseLib.fe2717a4.png";